import { Component, OnInit } from "@angular/core";
import { TableComponent } from "../table.component";
import { CareplusAgencyService } from "src/services/careplus-agency-service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { CareplusPaymentRequest } from "src/models/careplus-payment-requests";
import { Router } from "@angular/router";
import { StorageService } from "src/services/storage.service";
import { DomSanitizer } from "@angular/platform-browser";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { DocViewComponent } from "../model-dialog/doc-view/doc-view.component";

@Component({
  selector: "app-payment-status-verification",
  templateUrl: "./payment-status-verification.component.html",
  styleUrls: ["./payment-status-verification.component.css"],
})
export class PaymentStatusVerificationComponent
  extends TableComponent<CareplusPaymentRequest>
  implements OnInit
{
  displayedColumns: string[] = [
    "id",
    "submissionDate",
    "agencyName",
    "paymentMode",
    "bankName",
    "transactionReference",
    "chequeNo",
    "status",
    "transactionDate",
    "verificationDate",
    "totalBasePremium",
    "totalFee",
    "totalAmount",
    "totalDiscountAmount",
    "amountPaid",
    "customerCount",
    "batchId",
    "actions"
  ];

  constructor(
    private _agencyService: CareplusAgencyService,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _storageService: StorageService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
  ) {
    super(_agencyService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  getTableData() {
    const body = {
      isPending: true,
      ...this.getData(),
    };
    return this._agencyService.getPendingRequests(body);
  }

  openRequestDetail(row) {
    this._router.navigate(["/careplus/payment-verification-detail", row.id], {
      state: {
        agencyName: row.agencyName,
        consumerReference: row.consumerReference,
        status: row.status,
      },
    });
  }

  openAttachment(attachment: string) {
    if (!attachment) {
      this._snackBar.open("No attachment found", "CLOSE", { duration: 4000 });
      return;
    }

    this._storageService.getImage(attachment).subscribe(
      (response) => {
        const blob = new Blob([response], { type: response.type });
        const blobUrl = URL.createObjectURL(blob);
        const safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(blobUrl);

        this._dialog.open(DocViewComponent, {
          data: { url: safeUrl },
        });
      },
      (err) => {
        this._snackBar.open("Failed to load attachment", "CLOSE", {
          duration: 4000,
        });
      },
    );
  }
}
